/**
 *  this Hook will show the children content only if valid condition is true/valid. on a single line condition X ? Y :null
 * 
 * this hook is created to make more legible the information on the component
 * @param {boolean} {valid}
 * @returns 
 */
const Show = ({ valid, children }) => {
    return valid ? children : null;
}

export default Show;